import React from 'react';
import PropTypes from 'prop-types';
import AutoCompleteFilter from 'components/list/Filters/types/AutoCompleteFilter';
import RenderPercentageInputField from 'components/form/InputFields/RenderPercentageInputField';
import SubmitButton from 'components/button/SubmitButton';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { Field, isInvalid, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

const AccountYieldsCreateForm = (props) => {
    const {
        handleSubmit,
        handleSubmitForm,
        invalid,
        pristine,
        submitting,
        translate,
    } = props;

    return (
        <FormWrapper>
            <form onSubmit={ handleSubmit(handleSubmitForm) }>
                <Section>
                    <Row>
                        <Item>
                            <Field
                                component={ AutoCompleteFilter }
                                label='resources.account_yields.fields.accountId'
                                name='account_id'
                                optionValue='id'
                                reference='accounts'
                                searchBy='name'
                                searchParams={ {
                                    size: '12',
                                    sort_by: 'name',
                                    sort_direction: 'asc',
                                } }
                                source='account_id'
                            />
                        </Item>
                    </Row>

                    <Row>
                        <Item>
                            <Field
                                component={ RenderPercentageInputField }
                                fullWidth={ true }
                                label={ translate('resources.account_yields.fields.yield') }
                                max='80'
                                min='-20'
                                name='yield'
                                validate={ validations.required }
                            />
                        </Item>
                    </Row>
                </Section>

                <Section>
                    <Row>
                        <ButtonWrapper>
                            <SubmitButton
                                disabled={ pristine || submitting || invalid }
                                loading={ submitting }
                            />
                        </ButtonWrapper>
                    </Row>
                </Section>
            </form>
        </FormWrapper>
    );
};

AccountYieldsCreateForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    return {
        invalid: isInvalid(form)(state),
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        null,
    ),
    reduxForm({
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;

            if (!values.account_id) {
                errors.account_id = translate('forms.required');
            }

            if (!values.yield) {
                errors.yield = translate('forms.required');
            }

            return errors;
        },
    }),
);

export default enhance(AccountYieldsCreateForm);



// WEBPACK FOOTER //
// ./src/pages/account-yields/create/AccountYieldsCreateForm.js